export default async function DownloadCorrespondence(
    correspondence
    ) {
    const baseUrl = "/api/tal/policy/downloadcorrespondence"; 

    const constructUrl = () => {
        var origin = "";

        if (window.location.origin === "http://localhost:3000") {
            // note: local testing
            origin = "https://adviser-local.delivery.lan";
        }
        return origin + baseUrl + "?fileName=" +correspondence.fileName +
            "&filePath=" + correspondence.filePath +
            "&isEcmDocument=" + correspondence.isecmDocument;           
    }

   const downloadPDF = (response, fileName, contentType) => {
     var blob = new Blob([response], { type: contentType });        
     var url = URL.createObjectURL(blob);
     if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, fileName);
     }
     else
     {
        var link = document.createElement('a');
        link.setAttribute('href', url);
        link.setAttribute("download", fileName);
        var clickEvent = new MouseEvent("click", {
                         "view": window,
                         "bubbles": true,
                         "cancelable": false
        });
        link.dispatchEvent(clickEvent);
      }
}
    
    try {
        const response = await fetch(constructUrl(), {
            "method": "GET"
        });
        
        if (!response) {
            throw Error("No response");
        }
        else if (!response.ok) {
            throw Error(response.statusText);
        }  
            var fileName = correspondence.fileName;
            if(response && response.headers)
            {
            var disposition = response.headers.get('content-disposition');
            var contentType = response.headers.get('content-type');
            }
            if(disposition && disposition.split(';').length > 0)
            {
                 fileName =  disposition.split(';')[1].trim().replace('filename=','');
                 fileName = fileName.replace(/\"/g, "");
            }
            // Read the data
            let receivedLength = 0; // received that many bytes at the moment
            let chunks = [];          
           if(response.body)
           {
            const reader = response.body.getReader();
            while (true)
             {
                 const { done, value } = await reader.read();
                 if (done) { 
                    break;
                 }
                 chunks.push(value);
                 receivedLength += value.length;                 
            } 
            //Concatenate chunks into single Uint8Array
            let chunksAll = new Uint8Array(receivedLength); // (4.1)
            let position = 0;
           for(let chunk of chunks) {
                chunksAll.set(chunk, position); // (4.2)
                position += chunk.length;}
 
            if(chunksAll &&  chunksAll.buffer)
            {                    
                  downloadPDF(chunksAll.buffer, fileName, contentType);
            }      
        }        
    } catch (error) {
        console.log(error);
    }
}